import React from 'react';

interface ActionButton {
  text: string;
  onClick: () => void;
}

interface SelectionToolbarProps {
  selectionMode: boolean;
  toggleSelectionMode: () => void;
  selectedCount: number;
  totalCount: number;
  onSelectAll: () => void;
  actionButton?: ActionButton;
  allSelected: boolean;
}

const SelectionToolbar: React.FC<SelectionToolbarProps> = ({
  selectionMode,
  toggleSelectionMode,
  selectedCount,
  totalCount,
  onSelectAll,
  actionButton,
  allSelected
}) => {
  return (
    <div className="bg-gray-100 p-3 mb-4 rounded-md flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button
          className={`px-4 py-2 rounded-md font-medium transition-colors ${
            selectionMode
              ? 'bg-red-500 text-white hover:bg-red-600'
              : 'bg-blue-500 text-white hover:bg-blue-600'
          }`}
          onClick={toggleSelectionMode}
        >
          {selectionMode ? 'Exit Selection' : 'Select Images'}
        </button>
        
        {selectionMode && (
          <>
            <button
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md font-medium transition-colors"
              onClick={onSelectAll}
            >
              {allSelected ? 'Deselect All' : 'Select All'}
            </button>
            
            <span className="text-gray-700">
              {selectedCount} of {totalCount} selected
            </span>
          </>
        )}
      </div>
      
      {selectionMode && actionButton && (
        <button
          className={`px-4 py-2 rounded-md font-medium transition-colors ${
            selectedCount > 0
              ? 'bg-green-500 text-white hover:bg-green-600'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          disabled={selectedCount === 0}
          onClick={actionButton.onClick}
        >
          {actionButton.text}
        </button>
      )}
    </div>
  );
};

export default SelectionToolbar;